import type { SprintStatus } from '@hygge/shared';
import { cn } from '@/lib/utils';

const SPRINT_STATUS_CONFIG: Record<SprintStatus, { label: string; className: string }> = {
  planning: { label: 'Planning', className: 'bg-blue-500/10 text-blue-500 border-blue-500/20' },
  active: { label: 'Active', className: 'bg-green-500/10 text-green-500 border-green-500/20' },
  completed: { label: 'Completed', className: 'bg-hygge/10 text-hygge border-hygge/20' },
  cancelled: { label: 'Cancelled', className: 'bg-rose-500/10 text-rose-500 border-rose-500/20' },
};

export function SprintStatusBadge({
  status,
  className,
}: {
  status: SprintStatus;
  className?: string;
}) {
  const c = SPRINT_STATUS_CONFIG[status];
  return (
    <span
      className={cn(
        'inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-medium border',
        c.className,
        className,
      )}
    >
      {c.label}
    </span>
  );
}
